/**
 * Privacy & Consent Notice content by language.
 * Add or edit entries here; rendered in login modal and /:lang/privacy-consent page.
 */
export const PRIVACY_CONSENT_NOTICE = {
  hi: {
    title: "गोपनीयता और सहमति सूचना",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1. यह सूचना आपको सूचित करने के लिए है कि हम, कॉर्टेवा एग्रीसाइंस इंडिया प्राइवेट लिमिटेड, इसकी मूल कंपनी एवं संबद्ध कंपनियाँ (“कॉर्टेवा एग्रीसाइंस”) आपके व्यक्तिगत डेटा को कैसे संसाधित करना चाहते हैं, ताकि आप सूचित सहमति प्रदान कर सकें।",
      },
      {
        type: "heading",
        text: "संग्रहित और संसाधित व्यक्तिगत डेटा",
      },
      {
        type: "paragraph",
        text: "2. कॉर्टेवा द्वारा आपके से एकत्रित किए जाने वाले व्यक्तिगत डेटा के प्रकार इस बात पर निर्भर करेंगे कि आप कॉर्टेवा के साथ कैसे संवाद करते हैं और उन संवादों में आप कौन सा व्यक्तिगत डेटा प्रदान करते हैं। सामान्यतः, कॉर्टेवा निम्नलिखित व्यक्तिगत जानकारी आपसे संग्रहित और संसाधित करेगा। इस सूचना में उल्लेखित उद्देश्यों के लिए केवल निम्नलिखित व्यक्तिगत डेटा आपसे एकत्र किया जाएगा:",
      },
      {
        type: "list",
        items: ["I. नाम:", "II. फ़ोन नंबर:", "III. क्षेत्र/स्थान:"],
      },
      {
        type: "heading",
        text: "व्यक्तिगत डेटा का प्रसंस्करण",
      },
      {
        type: "paragraph",
        text: "3. उपरोक्त सूचीबद्ध व्यक्तिगत डेटा का उपयोग निम्नलिखित उद्देश्यों के लिए किया जाएगा, जब कॉर्टेवा के पास लागू कानून के अंतर्गत वैध आधार हो या आपकी स्पष्ट सहमति हो, कॉर्टेवा एवं उसके सेवा प्रदाता व्यक्तिगत डेटा का उपयोग निम्नलिखित प्रयोजनों के लिए करेंगे:",
      },
      {
        type: "list",
        items: [
          "I. नाम, फ़ोन नंबर और ईमेल का उपयोग स्ट्रॉन्गआर्म और गैलन्ट रिवॉर्ड प्रोग्राम के लिए आपको ग्राहक के रूप में पंजीकृत करने के लिए किया जाएगा।",
          "II. क्षेत्र/स्थान का उपयोग माल और सेवाएं प्रदान करने के लिए किया जाएगा।",
        ],
      },
      {
        type: "paragraph",
        text: "4. आपका व्यक्तिगत डेटा भारत के बाहर संग्रहित या संसाधित किया जा सकता है। कॉर्टेवा केवल उतना ही व्यक्तिगत डेटा संग्रहित और संसाधित करता है, जितना उपरोक्त उद्देश्यों के लिए आवश्यक है। हम केवल उतना ही व्यक्तिगत डेटा संग्रहित करेंगे जितना इस सूचना में वर्णित उद्देश्यों के लिए आवश्यक हो। व्यक्तिगत डेटा का उपयोग किसी अन्य उद्देश्य के लिए नहीं किया जाएगा।",
      },
      {
        type: "heading",
        text: "व्यक्तिगत डेटा का संरक्षण",
      },
      {
        type: "paragraph",
        text: "5. कॉर्टेवा व्यक्तिगत डेटा को तब तक रखेगा जब तक आवश्यक हो या लागू कानून के अनुसार अनुमति हो, और यह इस बात पर आधारित होगा कि डेटा किस उद्देश्य से प्राप्त किया गया था। संरक्षण अवधि निर्धारित करने के लिए उपयोग किए जाने वाले मानदंड निम्नलिखित हैं:",
      },
      {
        type: "list",
        items: [
          "I. उस अवधि की लंबाई जिसके दौरान कॉर्टेवा का आपके साथ जारी संबंध है और उसके बाद की वह अवधि जिसके दौरान हमें किसी उत्पन्न होने वाली समस्या के समाधान हेतु आपके व्यक्तिगत डेटा का संदर्भ लेने की वैध आवश्यकता हो सकती है।",
          "II. क्या कॉर्टेवा पर कोई कानूनी बाध्यता लगेगी (उदाहरण के लिए, कुछ कानून कॉर्टेवा को बाध्य करते हैं कि वे आपके लेन-देन के रिकॉर्ड एक निश्चित अवधि तक रखें, जिसके बाद उन्हें मिटाया जा सकता है)।",
          "III. क्या कॉर्टेवा की कानूनी स्थिति के मद्देनज़र संरक्षण उचित है (जैसे निर्धारित समय-सीमा, मुकदमेबाजी या नियामक जांचों के संबंध में)। हम आपकी व्यक्तिगत डेटा का प्रसंस्करण केवल तब तक करेंगे जब तक उपरोक्त उद्दिष्ट पूरे नहीं हो जाते:",
        ],
      },
      {
        type: "list",
        items: [
          "a) नाम, फ़ोन नंबर और ईमेल केवल तब तक संग्रहित किया जाएगा जब तक आप हमारे ग्राहक बने रहेंगे।",
          "b) क्षेत्र/स्थान केवल तब तक रखा जाएगा जब तक माल और सेवाएं प्रदान की गई हों।",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "आपके गोपनीयता अधिकार",
      },
      {
        type: "paragraph",
        text: "6. आप किसी भी समय अपनी व्यक्तिगत डेटा के प्रसंस्करण हेतु अपनी सहमति वापस ले सकते हैं, इसके लिए कृपया यहाँ क्लिक करें https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in और दिए गए चरणों का पालन करें। यदि आप ऐसा करते हैं, तो आपका व्यक्तिगत डेटा मिटा दिया जाएगा, जब तक कि उसे रखने की कोई कानूनी आवश्यकता न हो।",
      },
      {
        type: "paragraph",
        text: "7. आप अपने अधिकारों का प्रयोग कर सकते हैं, अपने व्यक्तिगत डेटा के प्रसंस्करण के संबंध में कोई प्रश्न उठा सकते हैं या शिकायत दर्ज करा सकते हैं, इसके लिए हमसे संपर्क करें: https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html ग्राहक सूचना केंद्र, कॉर्टेवा एग्रीसाइंस, 12वीं मंजिल, एट्रिया, वी असेंडास आईटी पार्क, माधापुर, हैदराबाद 500081 या 1860 1800 186। यदि आपकी शिकायत का समाधान हमारे द्वारा नहीं किया जाता है, तो आप लागू कानून के तहत निर्दिष्ट तरीके से भारत के डेटा संरक्षण बोर्ड में शिकायत दर्ज करा सकते हैं।",
      },
      {
        type: "paragraph",
        text: "मैं पुष्टि करता/करती हूँ कि मैंने गोपनीयता सूचना पढ़ ली है और समझ ली है तथा मैं यहाँ पर उपरोक्त उल्लिखित व्यक्तिगत डेटा के संग्रहण एवं प्रसंस्करण के लिए अपनी सहमति प्रदान करता/करती हूँ।",
        emphasis: true,
      },
    ],
  },
  mr: {
    title: "गोपनीयता आणि संमती सूचना",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1. ही सूचना आपल्याला सूचित करण्यासाठी आहे की आम्ही, कोरटेव्हा अ‍ॅग्रीसाइन्स इंडिया प्रा. लिमिटेड, त्याची पेरेंट कंपनी आणि शाखा (“कोरटेव्हा अ‍ॅग्रीसाइन्स”) आपला वैयक्तिक डेटा कसा प्रक्रिया करू इच्छितो, जेणेकरून आपण आपली सूचित संमती देऊ शकता.",
      },
      {
        type: "heading",
        text: "वैयक्तिक डेटाचा संग्रह आणि प्रक्रिया",
      }, 
      {
        type: "paragraph",
        text: "2. कोरटेव्हा आपल्याकडून गोळा करू शकणाऱ्या वैयक्तिक डेटाच्या प्रकारांमध्ये आपण कोरटेव्हाशी कसा संवाद साधता आणि त्या संवादांमध्ये आपण कोणती वैयक्तिक माहिती प्रदान करता यानुसार फरक पडू शकतो. सामान्यतः, कोरटेव्हा आपल्याकडून खालील वैयक्तिक माहिती गोळा करेल आणि प्रक्रियेत आणेल. या सूचनेत नमूद केलेल्या उद्दिष्टांसाठी केवळ खालील वैयक्तिक डेटा गोळा केला जाईलः",
      },
      {
        type: "list",
        items: ["I. नाव:", "II. फोन नंबर:", "III. क्षेत्र/स्थान:"],
      },
      {
        type: "heading",
        text: "वैयक्तिक डेटाची प्रक्रिया",
      },
      {
        type: "paragraph",
        text: "3. वरील नमूद केलेल्या वैयक्तिक डेटाचा वापर खालील उद्दिष्टांसाठी केला जाईल, जेव्हा कोरटेव्हाला लागू कायद्यांतर्गत वैध आधार आहे किंवा आपल्या स्पष्ट संमतीसह, कोरटेव्हा आणि तिचे सेवा प्रदाते वैयक्तिक डेटाचा वापर खालील उद्दिष्टांसाठी करतील:",
      },
      {
        type: "list",
        items: [
          "I. नाव, फोन नंबर आणि ईमेलचा वापर स्ट्रॉंगआर्म आणि गॅलंट रिवॉर्ड प्रोग्रामसाठी ग्राहक म्हणून आपले नोंदणी करण्यासाठी केला जाईल.",
          "II. क्षेत्र/स्थानाचा वापर वस्तू आणि सेवा पुरवण्यासाठी केला जाईल.",
        ],
      },
      {
        type: "paragraph",
        text: "4. आपल्या वैयक्तिक डेटाचा संग्रह किंवा प्रक्रिया भारताबाहेरही होऊ शकते. कोरटेव्हा केवळ वर नमूद उद्दिष्टांसाठी आवश्यक तेव्हढाच वैयक्तिक डेटा गोळा करेल व प्रक्रिया करेल. आम्ही केवळ आवश्यक त्या वैयक्तिक डेटाच गोळा करू. वैयक्तिक डेटाचा वापर इतर कोणत्याही उद्दिष्टासाठी केला जाणार नाही.",
      },
      {
        type: "heading",
        text: "वैयक्तिक डेटाची राखण",
      },
      {
        type: "paragraph",
        text: "5. कोरटेव्हा वैयक्तिक डेटाची राखण आवश्यक किंवा परवानगी असलेल्या कालावधीसाठी करेल, जसे की डेटास संकलित करण्याच्या उद्दिष्टांसाठी लागू कायद्यांशी सुसंगत आहे. राखणीची कालमर्यादा ठरवताना खालील निकष विचारात घेतले जातात:",
      },
      {
        type: "list",
        items: [
          "I. कोरटेव्हा आपल्याशी असलेल्या चालू नात्याचा कालावधी आणि त्यानंतरचा कालावधी ज्यादरम्यान आपल्याशी संबंधित प्रश्न सोडवण्यासाठी वैध गरज भासू शकते.",
          "II. कोरटेव्हा कोणत्याही कायदेशीर बंधनाखाली आहे का (उदा. काही कायदे आपल्याशी संबंधित व्यवहारांची नोंद विशिष्ट कालावधीसाठी ठेवल्यावरच आम्ही ती हटवू शकतो).",
          "III. राखण ही कोरटेव्हाच्या कायदेशीर स्थितीच्या दृष्टीने शिफारशी आहे का (उदा. वैध मुदती, न्यायालयीन कारवाई किंवा नियमकांची चौकशी यासंबंधी). आम्ही आपला वैयक्तिक डेटा फक्त त्या उद्दिष्टांसाठी प्रक्रिया करू ज्या पूर्ण झाल्या आहेत:",
        ],
      },
      {
        type: "list",
        items: [
          "a) नाव, फोन नंबर आणि ईमेल केवळ आपण आमचे ग्राहक असल्यापर्यंत राखले जातील.",
          "b) क्षेत्र/स्थान केवळ वस्तू आणि सेवा प्रदान झाल्यानंतरच राखले जाईल.",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "आपल्या गोपनीयतेचे अधिकार",
      },
      {
        type: "paragraph",
        text: "6. आपण कधीही आपली संमती मागे घेऊ शकता, यासाठी येथे क्लिक करा https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in आणि दिलेल्या सूचनांचे पालन करा. तसे केल्यावर आपला वैयक्तिक डेटा मिटवला जाईल, फक्त तेव्हा वगळता जेव्हा राखणे कायद्याने आवश्यक आहे.",
      },
      {
        type: "paragraph",
        text: "7. आपण आपले अधिकार व्यायाम करू शकता, वैयक्तिक डेटाच्या प्रक्रियेबाबत कोणतेही प्रश्न विचारू शकता किंवा तक्रार नोंदवू शकता खालील पत्त्यावर संपर्क करून: https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html ग्राहक माहिती केंद्र, कोरटेव्हा अ‍ॅग्रीसाइन्स, 12वा मजला, अत्रिया, व्ही असेन्दास आयटी पार्क, माधापूर, हैदराबाद 500081 किंवा 1860 1800 186. जर आपली तक्रार आमच्याकडून सुटली नाही, तर आपण लागू कायद्यानुसार भारतातील डेटा संरक्षण मंडळाकडे तक्रार नोंदवू शकता.",
      },
      {
        type: "paragraph",
        text: "मी पुष्टी करतो/करते की मी गोपनीयता सूचना वाचली आणि समजली आहे आणि मी येथे वर नमूद केलेल्या वैयक्तिक डेटाच्या संकलन व प्रक्रियेस माझी संमती देतो/देते.",
        emphasis: true,
      },
    ],
  },
  te: {
    title: "గోప్యత & అనుమతి నోటీసు",
    subtitle: "",
    blocks: [
      {
        type: "paragraph",
        text: "1. ఈ నోటీసు ద్వారా మేము, Corteva Agriscience India Private Limited, దాని ప్యారంట్ కంపెనీ మరియు అనుబంధ సంస్థలు (“Corteva Agriscience”) మీ వ్యక్తిగత డేటాను ఎలా ప్రాసెస్ చేయదలచుకున్నామో మిమ్మల్ని తెలియజేయడానికి ఉద్దేశించబడింది, తద్వారా మీరు స్వచ్ఛంద, అవగాహనపూర్వకమైన అనుమతి ఇవ్వవచ్చు.",
      },
      {
        type: "heading",
        text: "సంగ్రహించబడే మరియు ప్రాసెస్ చేయబడే వ్యక్తిగత డేటా",
      },
      {
        type: "paragraph",
        text: "2. Corteva మీతో ఎలా సంభందించదో, మీరు అందించే వ్యక్తిగత డేటా ఆధారంగా Corteva సేకరించే వ్యక్తిగత డేటా రకాలు మారవచ్చు. సాధారణంగా, Corteva మీ నుంచి ఈ క్రింది వ్యక్తిగత సమాచారాన్ని సేకరించి ప్రాసెస్ చేస్తుంది. ఈ నోటీసులో పేర్కొన్న ప్రయోజనాల కోసం కేవలం క్రింది వ్యక్తిగత డేటాను మాత్రమే సేకరిస్తాము:",
      },
      {
        type: "list",
        items: ["I. పేరు:", "II. ఫోన్ నెంబర్:", "III. ప్రాంతం/లొకేషన్:"],
      },
      {
        type: "heading",
        text: "వ్యక్తిగత డేటా ప్రాసెసింగ్",
      },
      {
        type: "paragraph",
        text: "3. Corteva సంబంధిత చట్టం కింద చెల్లుబాటు అయ్యే చట్టబద్ధమైన కారణం లేదా మీ స్పష్టమైన అనుమతి ఉన్నప్పుడు, Corteva మరియు దాని సేవా అందివార్పుదారులు కింది ఉద్దేశ్యాల కోసం వ్యక్తిగత డేటాను ఉపయోగిస్తారు:",
      },
      {
        type: "list",
        items: [
          "I. పేరు, ఫోన్ నెంబర్ మరియు ఇమెయిల్ Strongarm మరియు Gallant రివార్డ్ ప్రోగ్రామ్‌లో మీరు కస్టమర్ గా రిజిస్టర్ చేసుకోడానికి ఉపయోగిస్తారు.",
          "II. ప్రాంతం/లొకేషన్ వస్తువులు మరియు సేవలను అందించడానికి ఉపయోగిస్తారు.",
        ],
      },
      {
        type: "paragraph",
        text: "4. మీరు అందించిన వ్యక్తిగత డేటా భారతదేశం బయట నిల్వ చేయబడవచ్చు లేదా ప్రాసెస్ చేయబడవచ్చు. Corteva పై పేర్కొన్న ఉద్దేశ్యాల కొరకు మాత్రమే అవసరమైనంత పరిమాణంలో మాత్రమే వ్యక్తిగత డేటాను సేకరిస్తుంది మరియు ప్రాసెస్ చేస్తుంది. వ్యక్తిగత డేటా మరే ఇతర దృష్టితో ఉపయోగించబడదు.",
      },
      {
        type: "heading",
        text: "వ్యక్తిగత డేటా నిల్వ పరిమితి",
      },
      {
        type: "paragraph",
        text: "5. Corteva వివిధ ఉద్దేశ్యాలకనుగుణంగా తదుపరి చట్టబద్ధమైన పరిమితులను పరిగణనలోకి తీసుకొని అవసరమున్నంత కాలం వ్యక్తిగత డేటాను నిల్వ చేసి ఉంచుతుంది. నిర్ధారణకు గల ప్రమాణాలు:",
      },
      {
        type: "list",
        items: [
          "I. Corteva మీతో కొనసాగుతున్న సంబంధం పొడవు మరియు ఆ తర్వాత కూడా కచ్చితమైన అవసరాలను తీర్చుకోవడానికి వ్యక్తిగత డేటాను ఉల్లేఖించాల్సి ఉండే కాల పరిధి.",
          "II. Corteva కింద ఉన్న చట్టపరమైన బాధ్యతలు (ఉదాహరణకు, కొన్ని చట్టాలు ట్రాన్జాక్షన్లను ప్రత్యేక కాలం నాటికి రికార్డుగా ఉంచాలని ఆదేశిస్తాయి).",
          "III. Corteva యొక్క చట్టబద్ధ స్థితిని పరిగణించి నిల్వ అవసరమా లేదా (మినహా వర్తించు పరిమితకాల చట్టాలు, న్యాయహిటాలు లేదా నియంత్రణ విచారణలు). మేము కేవలం క్రింద పేర్కొన్న సూక్ష్మకాలం పాటు మాత్రమే మీ వ్యక్తిగత డేటాను ప్రాసెస్ చేస్తాము:",
        ],
      },
      {
        type: "list",
        items: [
          "a) పేరు, ఫోన్ నెంబర్ మరియు ఇమెయిల్ మీరు మా కస్టమర్ గా ఉన్నంత కాలం మాత్రమె నిల్వ చేస్తాము.",
          "b) ప్రాంతం/లొకేషన్ వస్తువులు మరియు సేవలు అందించినంత కాలం మాత్రమే నిల్వ చేస్తాము.",
        ],
        listClass: "privacy-consent-sublist",
      },
      {
        type: "heading",
        text: "మీ గోప్యతా హక్కులు",
      },
      {
        type: "paragraph",
        text: "6. మీరు మీ వ్యక్తిగత డేటా ప్రాసెసింగ్ ప్రమాణాలపై ఎప్పుడైనా అనుమతిని రద్దు చేసుకోవచ్చు, దీనికోసం దిగువ లింక్ కి జనుకున్నతనం ద్వారా దశలను అనుసరించండి: https://dataprivacyrequest.corteva.com/consumer/region/privacy_request?uid=in అలా చేస్తే, ఎలాంటి చట్టబద్ధ అవసరం లేని పక్షంలో మీ వ్యక్తిగత డేటా తొలగించబడుతుంది.",
      },
      {
        type: "paragraph",
        text: "7. మీరు మీ హక్కులను వ్యాయామం చేయవచ్చు, మీ వ్యక్తిగత డేటా ప్రాసెసింగ్ గురించి సందేహాలు కలిగితే అడగవచ్చు లేదా ఫిర్యాదు నమోదు చేసుకోవచ్చు ఈ ద్వారా సంప్రదించండి: https://www.corteva.com/content/corteva/as/in/en/homepage/privacy-policy.html Customer Information Center, Corteva AgriScience, 12th floor, Atria, V Ascendas IT park, Madhapur, Hyderabad 500081 లేదా 1860 1800 186. మా ద్వారా మీ ఫిర్యాదు పరిష్కరించబడకపోతే, మీరు వర్తించు చట్టం ప్రకారం భారతదేశ డేటా రక్షణ బోర్డుతో ఫిర్యాదు నమోదు చేసుకోవచ్చు.",
      },
      {
        type: "paragraph",
        text: "నేను గోప్యతా నోటీసు చదివి అర్థం చేసుకున్నానని మరియు పైన తెలిపినట్లు వ్యక్తిగత డేటా సేకరణ మరియు ప్రాసెసింగ్ పై అనుమతి అందిస్తున్నానని ధృవీకరిస్తున్నాను.",
        emphasis: true,
      },
    ],
  },
};

export const getPrivacyConsentNotice = (lang) =>
  PRIVACY_CONSENT_NOTICE[lang] || PRIVACY_CONSENT_NOTICE.hi;
